<section class="jurisdiction-row-card" [formGroup]="formGroup">
  <div class="jurisdiction-grid">
    <div class="d-flex flex-column gap-1">
      <app-final-location-jurisdiction-title
        *ngIf="jurisdictionId !== null"
        class="title-sm"
        [jurisdictionId]="jurisdictionId"
        [finalLocationId]="overrideJurisdictionId" />
      <div *ngIf="jurisdictionId === null" class="title-sm" i18n>Non-Locked-In</div>
      <div class="currency-amount">{{ totalBalance | currency }}</div>
    </div>

    <div class="balance-sections">
      <div *ngIf="lockedBalance > 0" class="balance-section">
        <div class="d-flex flex-column gap-1">
          <div class="d-flex align-items-center">
            <span class="title-sm" i18n>Locked-In</span>
            <img
              *ngIf="hasUnlock$ | async; else lockedIcon"
              class="ms-1"
              src="assets/icons/dark/Lock%20Off.svg"
              alt=""
              [style.width.rem]="1"
              [style.height.rem]="1" />
            <ng-template #lockedIcon>
              <img
                class="ms-1"
                src="assets/icons/dark/Lock%20On.svg"
                alt=""
                [style.width.rem]="1"
                [style.height.rem]="1" />
            </ng-template>
            <button *ngIf="showUnlock" type="button" class="link-button no-style-button ms-3" (click)="onUnlockClick()">
              {{ unlockButtonLabel$ | async }}
            </button>
          </div>
          <div class="d-flex align-items-baseline" [style.gap.rem]="0.5">
            <span class="currency-amount">{{ effectiveLockedBalance$ | async | currency }}</span>
            <span *ngIf="hasUnlock$ | async" class="currency-amount previous-amount">
              <span class="visually-hidden" i18n>Before unlock:</span>
              {{ lockedBalance | currency }}
            </span>
          </div>
        </div>

        <div class="use-all-cell d-flex align-items-center gap-2">
          <ng-container *ngIf="isSpecifyAmount$ | async">
            <app-checkbox-input
              [controlId]="'useEntireLockedBalance-' + jurisdictionId"
              formControlName="useEntireLockedBalance" />
            <app-form-option-label [labelFor]="'useEntireLockedBalance-' + jurisdictionId" i18n>
              Use All
            </app-form-option-label>
          </ng-container>
        </div>
        <div class="d-flex flex-column gap-1">
          <ng-container *ngIf="isSpecifyAmount$ | async">
            <app-currency-input
              [controlId]="'desiredLockedStartBalance-' + jurisdictionId"
              [error]="formSubmitted && formGroup.controls.desiredLockedStartBalance.invalid"
              formControlName="desiredLockedStartBalance"
              placeholder="0.00" />
            <app-form-error
              *ngIf="formSubmitted && formGroup.controls.desiredLockedStartBalance.invalid"
              [errors]="formGroup.controls.desiredLockedStartBalance.errors"
              [customErrorMessages]="customLockedAmountErrorMessages" />
          </ng-container>
        </div>

        <div class="d-flex justify-content-center align-items-center">
          <img
            *ngIf="showLockedCheck$ | async"
            src="assets/icons/primary/Circle%20Check.svg"
            alt=""
            i18n-alt
            [style.width.rem]="1.5"
            [style.height.rem]="1.5" />
        </div>
      </div>

      <hr *ngIf="lockedBalance > 0 && (showUnlockedSection$ | async)" class="balance-section-divider" />

      <div *ngIf="showUnlockedSection$ | async" class="balance-section">
        <div class="d-flex flex-column gap-1">
          <div class="d-flex align-items-center gap-2">
            <span class="title-sm" i18n>Non-Locked-In</span>
          </div>
          <div class="d-flex align-items-baseline" [style.gap.rem]="0.5">
            <span class="currency-amount">{{ effectiveUnlockedBalance$ | async | currency }}</span>
            <span *ngIf="hasUnlock$ | async" class="currency-amount previous-amount">
              <span class="visually-hidden" i18n>Before unlock:</span>
              {{ unlockedBalance | currency }}
            </span>
          </div>
        </div>

        <div class="use-all-cell d-flex align-items-center gap-2">
          <ng-container *ngIf="isSpecifyAmount$ | async">
            <app-checkbox-input
              [controlId]="'useEntireUnlockedBalance-' + jurisdictionId"
              formControlName="useEntireUnlockedBalance" />
            <app-form-option-label [labelFor]="'useEntireUnlockedBalance-' + jurisdictionId" i18n>
              Use All
            </app-form-option-label>
          </ng-container>
        </div>
        <div>
          <app-currency-input
            *ngIf="isSpecifyAmount$ | async"
            [controlId]="'desiredUnlockedStartBalance-' + jurisdictionId"
            formControlName="desiredUnlockedStartBalance"
            placeholder="0.00" />
        </div>

        <div class="d-flex justify-content-center align-items-center">
          <img
            *ngIf="showUnlockedCheck$ | async"
            src="assets/icons/primary/Circle%20Check.svg"
            alt=""
            i18n-alt
            [style.width.rem]="1.5"
            [style.height.rem]="1.5" />
        </div>
      </div>
    </div>
    <div class="error-text" role="alert" i18n *ngIf="formGroup?.errors?.unlockedFundsMustBeUsed && formSubmitted">
      Some of this jurisdiction's funds must be used to fund the retirement product.
    </div>
  </div>
</section>
